export const DELRAY_SQUARE_38 = {
    label: "Montigo Delray Square 38",
    value: "DELRAY_SQUARE_38",
    whatsWrong: "Firebox has heat or structure damage beyond repair",
    whatCaused: "Continued use of firebox, with malfunctioning refractory panels",
    additional: "The wall(s) of the firebox will continue to deteriorate with exposure to heat cycles. Possible CO leaks or heat transfer to combustibles.",
    repair: ["Prefab swap-out", "-Montigo DelRay Square 38", "-24,000 BTU Natural Gas w/ Proflame 2 IPI, downlighting, remote control, fan kit, Invisimesh Screen, battery backup, and venting", "-Birch logs, grey herringbone, trim", "*see below for more details"],
}